import styled, { css } from 'styled-components';

const ColumnTilesStyled = styled.div.attrs({
  className: 'columnTiles',
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      max-width: 1000px;
      max-height: 95%;
      padding: 16px;
      display: flex;
      gap: 25px;
      flex-direction: row;
      justify-content: space-evenly;
      color: border: ${colors.primary.dark};


      ${media.tablet.only} {
        width: 96vw;
      }

      ${media.mobile.down} {
        align-items: center;
        flex-direction: column;
      }
      .columnTiles-tile {
        border: 2px solid ${colors.secondary.dark};
        padding: 30px;
        box-sizing: border-box;
        border-radius: 16px;
        height: 280px;
        width: 280px;

        ${media.tablet.down} {
          height: 310px;
        }

        &-icon {
          height: 45px;
          width: 40px;
        }

        &-header {
          margin-top: 16px;
          font-weight: 700;
          font-size: 18px;
          line-height: 22px;
        }

        &-content {
          margin-top: 10px;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
        }
      }
      `;
  }}
`;

export default ColumnTilesStyled;
